import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import NavBar from './componentes/NavBar';
import WhatsappButton from './componentes/WhatsappButton';
import Footer from './componentes/Footer'; 
import ScrollToTop from './componentes/ScrollToTop'; // 🔥 IMPORTANTE: El componente mágico

import './App.css';

// ... Imports de páginas ...
import Inicio from './pages/Inicio';
import Informacion from './pages/Informacion';
import Gobierno from './pages/Gobierno';
import Noticias from './pages/Noticias';
import Tramites from './pages/Tramites';
import DetalleNoticia from './pages/DetalleNoticia';
import Administrativo1 from './pages/Administrativo1';
import AdministrativoB from './pages/AdministrativoB';
import AdministrativoC from './pages/AdministrativoC';
import AdministrativoD from './pages/AdministrativoD';
import AdministrativoE from './pages/AdministrativoE';
import InfoLicencia from './componentes/InfoLicencia';
import InfoCatastro from './componentes/InfoCatastro';

const Login = lazy(() => import('./pages/Login'));
const SECRET_LOGIN_PATH = "entrada-comuna";

function App() {
    return (
        <AuthProvider>
            {/* 🔥 AGREGADO: Esto resetea el scroll al cambiar de página */}
            <ScrollToTop />

            {/* Contenedor Flex para estructura correcta Sticky Footer */}
            <div className="app-container" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                
                <NavBar />
                
                <WhatsappButton />

                {/* El contenido principal crece para ocupar el espacio disponible */}
                <div className="main-content" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <Suspense fallback={<div className="loading-screen">Cargando...</div>}>
                        <Routes>
                            <Route path='/' element={<Inicio />} />
                            <Route path='/informacion' element={<Informacion />} />
                            <Route path='/gobierno' element={<Gobierno />} />
                            <Route path='/noticias' element={<Noticias />} />
                            <Route path='/tramites' element={<Tramites />} />
                            <Route path="/noticias/:id" element={<DetalleNoticia />} />

                            <Route path='/tramites/administrativos/licencia' element={<InfoLicencia />} />
                            <Route path='/tramites/administrativos/catastro' element={<InfoCatastro />} />

                            <Route path={`/${SECRET_LOGIN_PATH}`} element={<Login />} />

                            <Route path='/tramites/administrativos/a' element={<Administrativo1 />} />
                            <Route path='/tramites/administrativos/b' element={<AdministrativoB />} />
                            <Route path='/tramites/administrativos/c' element={<AdministrativoC />} />
                            <Route path='/tramites/administrativos/d' element={<AdministrativoD />} />
                            <Route path='/tramites/administrativos/e' element={<AdministrativoE />} />

                            <Route path="*" element={<Inicio />} />
                        </Routes>
                    </Suspense>
                </div>

                {/* Footer al final */}
                <Footer />
                
            </div>
        </AuthProvider>
    );
}

export default App;